<template>
    <section class="container pl-6 pr-6">

      <div class="is-light mb-6">
        <h1 class="title has-text-centered gant-text">Welcome to TripCircuit, {{ $globals.profile.firstName }}</h1>
        <h2 class="subtitle has-text-centered gant-text">Your Online Travel Platform</h2>

        <!-- DESKTOP VIEW -->
        <div class="is-flex is-hidden-touch">
          <div class="is-flex is-align-content-center mr-3">
            <div v-animate-css="'fadeIn'">
              <img src="/images/SVGs/checkout-lady.svg" alt="Book Travel with Trip Circuit">
            </div>
            <div>
              <div class="boxWithBorder" style="margin-top: 60px; margin-left: -110px; position: relative; z-index: 20" @click="$nav.searchGo">
                <h2 class="is-size-4 "><b-icon icon="briefcase-search"> </b-icon> Book Travel </h2>
                <p>Search and book your flight, hotel, and car rental.</p>
                <b-button @click="$nav.searchGo" class="mt-5 is-primary is-hidden-touch" expanded>Start Your Booking</b-button>
              </div>
            </div>
          </div>
          <div class="is-flex is-align-content-center ml-3">
            <div>
              <div class="boxWithBorder" style="margin-top: 60px; margin-right: -30px; position: relative; z-index: 20" @click="$nav.tripsGo">
                <h2 class="is-size-4"><b-icon icon="briefcase"/> View My Trips </h2>
                <p>View your current and upcoming trips.</p>
                <b-button @click="$nav.tripsGo" class="mt-5 is-primary is-hidden-touch" expanded>View Trips </b-button>
              </div>
            </div>
            <div v-animate-css="'fadeIn'">
              <img src="/images/SVGs/checkout-guy.svg" alt="Book Travel with Trip Circuit">
            </div>
          </div>
        </div>

        <UserAirNotifications class="mt-3 mb-3"/>

        <!-- TOUCH VIEW -->
        <div class="columns has-text-centered is-hidden-desktop">
          <div class="column">
            <div class="box is-shadowless  rounded lightBackground has-text-black"  @click="$nav.searchGo">
              <h2 class="is-size-4 "><b-icon icon="briefcase-search"> </b-icon> Book Travel</h2>

              <p>Search flights, hotels, and car rentals.</p>

              <b-button @click="$nav.searchGo" class="mt-5 is-primary is-hidden-touch has-text-primary" expanded>Start Your Booking</b-button>
            </div>
          </div>
          <div class="column">
            <div class="box is-shadowless rounded lightBackground has-text-black" @click="$nav.tripsGo">
              <h2 class="is-size-4"><b-icon icon="briefcase"/> View My Trips</h2>

              <p>View your current and upcoming trips.</p>

              <b-button @click="$nav.tripsGo" class="mt-5 is-primary is-hidden-touch " expanded>View Trips </b-button>
            </div>
          </div>
          <!--<div class="column">
            <div class="box is-shadowless rounded lightBackground has-text-black" @click="$nav.profileGo">
              <h2 class="is-size-4">View My Profile <b-icon icon="account"/></h2>
              <p>View and manage your travel profile.</p>
              <b-button @click="$nav.profileGo" class="mt-5 is-primary is-hidden-touch" expanded>View Profile</b-button>
            </div>
          </div> -->
        </div>
        <div v-if="customMessage" v-html="customMessage" class="boxWithBorder">
        </div>
        <HomeWelcomeMessage v-if="!customMessage" />
      </div>
  </section>
</template>

<script>
  import UserAirNotifications from "../components/User/UserAirNotifications";
  import HomeWelcomeMessage from '../components/Dashboard/HomeWelcomeMessage.vue'
  import bookingMixin from "../mixins/bookingMixin";
  var moment = require('moment');

  export default {
    name: 'Home',
    components: {
      HomeWelcomeMessage,
      UserAirNotifications
      },
    mixins:[bookingMixin],
    data: function () {
        return {
          loading: true
      }
    },
    methods: {
      open() {
              setTimeout(() => this.loading = false)
          },
    },
    mounted(){
      setTimeout(() => this.loading = false, 3000);

    },
    computed: {
      customMessage(){
        if(!this.$globals.profile.tripCircuitConfiguration) return null

        return this.$globals.profile.tripCircuitConfiguration.customMessages.home
      }
    }
    }
</script>

<style >
  .lightBackground{
    background-color: #e4e8e8 !important;
  }
</style>

